import today from './today.js';
import welcome from './welcome.js';
import journey from './journey.js';
import chapter from './chapter.js';
import lesson from './lesson.js';
import read from './read.js';
import verse from './verse.js';
import explore from './explore.js';
import concepts from './concepts.js';
import concept from './concept.js';
import people from './people.js';
import person from './person.js';
import search from './search.js';
import saved from './saved.js';
import settings from './settings.js';
import about from './about.js';
import signin from './signin.js';
import guide from './guide.js';
import notfound from './notfound.js';

export default { today, welcome, journey, chapter, lesson, read, verse, explore, concepts, concept, people, person, search, saved, settings, about, signin, guide, notfound };
